export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center pt-[72px] overflow-hidden"
    >
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            'url(https://readdy.ai/api/search-image?query=Warm%20abstract%20entertainment%20news%20background%20with%20soft%20gradient%20orange%20and%20amber%20tones%2C%20subtle%20geometric%20patterns%2C%20modern%20minimal%20design%2C%20clean%20atmosphere%2C%20soft%20diffused%20light%2C%20no%20text%20or%20people&width=1600&height=900&seq=hero-bg-2026&orientation=landscape)',
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/45"></div>

      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full">
            <span className="inline-block px-4 py-1.5 rounded-full text-xs font-medium bg-accent-500/20 text-accent-300 border border-accent-500/30 mb-5 whitespace-nowrap">
              今日热瓜 · 实时更新
            </span>

            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-background-50 leading-tight mb-3">
              51吃瓜在线
              <span className="block text-xl md:text-2xl lg:text-3xl font-sans font-light text-background-200 mt-2">
                第一时间吃最全的瓜
              </span>
            </h1>

            <p className="text-sm md:text-base text-background-200/90 leading-relaxed max-w-xl mt-6">
              51吃瓜在线是面向全网娱乐资讯爱好者的综合入口平台，涵盖明星动态、综艺追剧、网红圈、影视音乐等热门领域。
              编辑团队全天候追踪全网热点，多源交叉验证确保信息可靠。无论你身在何处，只需打开最新网址即可畅快吃瓜，
              更支持手机版与APP下载，让精彩内容随身而行。
            </p>
            <p className="text-sm md:text-base text-background-200/90 leading-relaxed max-w-xl mt-3">
              当前全网热议焦点集中在顶流艺人私生活曝光、热门综艺录制黑幕与影视行业新势力崛起三大方向，
              话题热度持续攀升，吃瓜正当时。
            </p>

            <div className="flex flex-wrap items-center gap-5 md:gap-8 mt-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-400">5,000万+</div>
                <div className="text-xs text-background-300 mt-1">月活跃吃瓜群众</div>
              </div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-primary-400">24h</div>
                <div className="text-xs text-background-300 mt-1">全天候实时更新</div>
              </div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-secondary-400">50+</div>
                <div className="text-xs text-background-300 mt-1">合作媒体信源</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-3 mt-8">
              <a
                href="#cards"
                className="inline-flex items-center justify-center px-7 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line mr-2"></i>
                立即吃瓜
              </a>
              <a
                href="#app"
                className="inline-flex items-center justify-center px-7 py-3 rounded-full border border-background-200/50 text-background-100 font-medium text-sm hover:bg-background-50/10 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-download-line mr-2"></i>
                下载APP
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[480px] aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20entertainment%20news%20platform%20concept%20with%20vibrant%20warm%20orange%20and%20amber%20gradient%20background%2C%20floating%20news%20cards%20and%20headlines%2C%20dynamic%20composition%2C%20editorial%20design%20style%2C%20clean%20modern%20aesthetic%2C%20no%20text%20visible&width=960&height=720&seq=hero-main-2026&orientation=landscape"
                alt="51吃瓜在线娱乐资讯平台主视觉"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 rounded-2xl ring-1 ring-inset ring-background-50/10"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}